import { useEffect } from 'react';

export const SEOProtection = ({ noIndex = false }) => {
  useEffect(() => {
    if (noIndex) {
      // Add noindex meta tag
      const metaTag = document.createElement('meta');
      metaTag.name = 'robots';
      metaTag.content = 'noindex, nofollow, noarchive, nosnippet, noimageindex';
      document.head.appendChild(metaTag);

      // Add additional protection meta tags
      const googleBotTag = document.createElement('meta');
      googleBotTag.name = 'googlebot';
      googleBotTag.content = 'noindex, nofollow, noarchive, nosnippet, noimageindex';
      document.head.appendChild(googleBotTag);

      const bingBotTag = document.createElement('meta');
      bingBotTag.name = 'bingbot';
      bingBotTag.content = 'noindex, nofollow, noarchive, nosnippet, noimageindex';
      document.head.appendChild(bingBotTag);

      // Cleanup function to remove meta tags when component unmounts
      return () => {
        if (metaTag.parentNode) {
          metaTag.parentNode.removeChild(metaTag);
        }
        if (googleBotTag.parentNode) {
          googleBotTag.parentNode.removeChild(googleBotTag);
        }
        if (bingBotTag.parentNode) {
          bingBotTag.parentNode.removeChild(bingBotTag);
        }
      };
    }
  }, [noIndex]);

  return null; // This component doesn't render anything
};
